import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeaturesFlagsService {
  uriFeaturesFlags = `${environment.webappEndpoint}/features`;

  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
  ) { }

  // endpoint /:featureName/receiver/:receiverId
  getFeatureFlag = (featureName: string, receiverId: string) => this.http.get(`${this.uriFeaturesFlags}/${featureName}/receiver/${receiverId}`, { headers: { Authorization: `Bearer ${this.auth.getToken()}` }});
}
